import { render, staticRenderFns } from "./HumanVerification.vue?vue&type=template&id=32ed73fe&scoped=true"
import script from "./HumanVerification.vue?vue&type=script&lang=js"
export * from "./HumanVerification.vue?vue&type=script&lang=js"
import style0 from "./HumanVerification.vue?vue&type=style&index=0&id=32ed73fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ed73fe",
  null
  
)

export default component.exports
import {QInput,QBtn,QSpinner,QDialog} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QBtn,QSpinner,QDialog})
